import { connect } from 'react-redux';
import type { InsiderTradingAccordionProps } from '@/pages/CompanyReport/components/InsiderTradingTransactions';
import { InsiderTradingAccordion } from '@/pages/CompanyReport/components/InsiderTradingTransactions';
import { makeInsiderTradingTransactions } from '@/pages/CompanyReport/components/InsiderTradingTransactions/redux/selectors';

const makeMapStateToProps = () => {
  const insiderTradingTransactionsSelector = makeInsiderTradingTransactions();
  return (state, ownProps) =>
    ({
      data: insiderTradingTransactionsSelector(state, ownProps),
    }) satisfies InsiderTradingAccordionProps;
};

export default connect(makeMapStateToProps)(InsiderTradingAccordion);
